import ManagerBackgroundRequests from './managerBackgroundRequests';
import ManagerTournamentWS from './managerTournamentsWS';
import eTournamentsWS, { eNotificationTypes } from './eTournamentsWS';
import Utility from '../utility';
import { sleep } from '../utils/sleep';
import ManagerHttp from './managerHttp';
import ManagerGameRequests from './managerGameRequests';
import URLs from './URLs';

export default class ManagerServerCommunication {
  constructor(wrapperModel) {
    this._urlParams = Utility.urlParser.params;

    this._roundsHistoryApi = URLs.getURL(URLs.eURLsNames.EUN_ROUNDS_HISTORY_API);
    // this._roundsHistoryApi = 'http://0.0.0.0:8083/api/';
    this._analyticsApi = URLs.getURL(URLs.eURLsNames.EUN_BACKOFFICE_URL);
    // this._analyticsApi = `http://0.0.0.0:8085/api/public`;

    this._wrapperModel = wrapperModel;
    this._managerBackgroundRequests = new ManagerBackgroundRequests({
      api: this._urlParams.api,
      sid: this._urlParams.sid,
      gid: this._urlParams.gid
    });
    this.handleModelChange = this.handleModelChange.bind(this);
    this._wrapperModel.onChange.add(this.handleModelChange);
  }

  initManagerGameRequests({ developmentGetSessionPath, cheatsParams, baseData, handleWinLimits }) {
    this._managerGameRequests = new ManagerGameRequests({
      api: this._urlParams.api,
      sid: this._urlParams.sid,
      gid: this._urlParams.gid,
      cheatsParams: cheatsParams,
      developmentGetSessionPath: developmentGetSessionPath,
      baseData: baseData,
      handleWinLimits,
    });
  }

  sendGameInitRequest(data, doNotInitWrapperFreebets = false) {
    return this._managerGameRequests.sendGameInitRequest(data, doNotInitWrapperFreebets);
  }

  sendGameRequest(data, urlPath, dontSaveResponse) {
    return this._managerGameRequests.sendGameRequest(data, urlPath, dontSaveResponse);
  }

  // todo: move rounds history requests to separate class
  requestRoundsHistory(page) {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const promise = ManagerHttp.postRequest(this._roundsHistoryApi.concat('/rounds/get_history'), {
      sid: this._urlParams.sid,
      gid: this._urlParams.gid,
      region: this._wrapperModel.data.region,
      page,
    }, { signal }).then(res => {
      if (res) this._wrapperModel.update(prev => ({
        ...prev,
        rounds_history: {
          ...prev.rounds_history,
          rounds: {
            ...prev.rounds_history.rounds,
            list: [...prev.rounds_history.rounds.list, ...res.data.list],
            hasMore: res.data.hasMore,
          }
        }
      }));
    })
      .catch((error) => {
        console.error(error);
        if (error.name !== 'AbortError') {
          window.OPWrapperService.showError(window.OPWrapperService.errors.REQUEST_FAILED.CODE, null, false);
        }
      });

    return { abortRoundsRequest: () => abortController.abort(), promise };
  }

  requestRoundResult(round) {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const promise = ManagerHttp.postRequest(this._roundsHistoryApi.concat('/rounds/get_results'), {
      sid: this._urlParams.sid,
      gid: this._urlParams.gid,
      roundsParams: [round],
    }, { signal }).then(res => {
      if (res && res.data.length) this._wrapperModel.update(prev => ({
        ...prev,
        rounds_history: {
          ...prev.rounds_history,
          results: {
            ...prev.results,
            [round.region]: { ...prev.rounds_history.results[round.region], [round.id]: res.data[0] }
          }
        }
      }));
    })
      .catch((error) => {
        console.error(error);
        if (error.name !== 'AbortError') {
          window.OPWrapperService.showError(window.OPWrapperService.errors.REQUEST_FAILED.CODE, null, false);
        }
      });

    return { abortResultRequest: () => abortController.abort(), promise };
  }

  // todo: move analytics requests to separate class
  createBugReport({ description, file, captcha }) {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const headers = {
      'recaptcha-token': captcha,
    }

    const formData = new FormData();
    formData.append('sid', this._urlParams.sid);
    formData.append('gid', this._urlParams.gid);
    formData.append('operator_id', this._urlParams.pid);
    formData.append('casino_id', this._urlParams.casinoId || '');
    formData.append('bundle', this._wrapperModel.data.initConfig.bundle);
    formData.append('description', description);
    formData.append('user_agent', window.navigator.userAgent);
    if (file) formData.append('file', file);

    const promise = ManagerHttp.postRequest(
      this._analyticsApi.concat('/create_bug_report'),
      null,
      { signal, headers, body: formData }
    ).catch((error) => {
      console.error(error);
      if (error.name !== 'AbortError') {
        window.OPWrapperService.showError(window.OPWrapperService.errors.REQUEST_FAILED.CODE, null, false);
      }
    });

    return { abortRequest: () => abortController.abort(), promise };
  }

  createFeedback({
                   rating,
                   rules_feedback,
                   anticipated_feature,
                   visual_impressions,
                   compatibility_of_mechanics_and_visuals,
                   sound_liked,
                   played_with_sound,
                   proposals,
                   would_come_back,
                   why_not_come_back,
                   critics,
                   positives,
                   negatives,
                   comment,
                   twitter_nickname,
                   discord_nickname,
                   file,
                   captcha
                 }) {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const headers = {
      'recaptcha-token': captcha,
    }

    const formData = new FormData();
    formData.append('sid', this._urlParams.sid);
    formData.append('gid', this._urlParams.gid);
    formData.append('operator_id', this._urlParams.pid);
    formData.append('casino_id', this._urlParams.casinoId || '');
    formData.append('bundle', this._wrapperModel.data.initConfig.bundle);
    formData.append('rating', rating);
    formData.append('rules_feedback', rules_feedback);
    formData.append('anticipated_feature', anticipated_feature);
    formData.append('visual_impressions', visual_impressions);
    formData.append('compatibility_of_mechanics_and_visuals', compatibility_of_mechanics_and_visuals);
    formData.append('sound_liked', sound_liked);
    formData.append('played_with_sound', played_with_sound);
    formData.append('proposals', proposals);
    formData.append('would_come_back', would_come_back);
    formData.append('why_not_come_back', why_not_come_back);
    formData.append('critics', critics);
    formData.append('positives', positives);
    formData.append('negatives', negatives);
    formData.append('comment', comment);
    formData.append('twitter_nickname', twitter_nickname);
    formData.append('discord_nickname', discord_nickname);
    if (file) formData.append('file', file);

    const promise = ManagerHttp.postRequest(
      this._analyticsApi.concat('/create_feedback'),
      null,
      { signal, headers, body: formData }
    ).catch((error) => {
      console.error(error);
      if (error.name !== 'AbortError') {
        window.OPWrapperService.showError(window.OPWrapperService.errors.REQUEST_FAILED.CODE, null, false);
      }
    });

    return { abortRequest: () => abortController.abort(), promise };
  }

  async requestTournamentsInfo(...props) {
    const { data } = await this._managerTournamentWS.requestTournamentsInfo(...props);
    this._wrapperModel.update(prev => ({ ...prev, tournamentsInfo: data }));
  }

  async requestTournamentsLeaderboard(...props) {
    const { data } = await this._managerTournamentWS.requestLeaderboard(...props)

    const { type, tournamentId, ...tournamentData } = data;
    if (type === 'leaderboard') this._wrapperModel.update(prev => ({
      ...prev,
      tournamentsInfo: {
        ...prev.tournamentsInfo,
        data: {
          ...prev.tournamentsInfo.data,
          [tournamentId]: { ...prev.tournamentsInfo.data[tournamentId], ...tournamentData }
        }
      }
    }));
  }

  handleModelChange({ tournamentsInfo, partnerConfig, gameInited }) {
    if (!gameInited) return;

    if (tournamentsInfo) this._initTournamentWS(tournamentsInfo.ws.key);

    this._managerBackgroundRequests.statusCheckConfig = {
      checkStatus: partnerConfig.session.checkStatus,
      checkStatusInterval: partnerConfig.session.checkStatusInterval,
    };

    this._wrapperModel.onChange.remove(this.handleModelChange);
  }

  _initTournamentWS(authorizationToken) {
    this._managerTournamentWS = new ManagerTournamentWS({
      onMessage: this._onTournamentWSMessage.bind(this),
      onClose: this._requestTournamentsAuthorizationToken.bind(this),
      authorizationToken
    });
  }

  async _requestTournamentsAuthorizationToken() {
    await sleep(30000);

    const response = await this.getTournamentsAuthorizationToken();
    let key;

    if (response) {
      key = response.ws.key;
      this._managerTournamentWS.authorizationToken = key;
    }

    this._wrapperModel.update(prev => ({
      ...prev,
      tournamentsInfo: { ...prev.tournamentsInfo, ws: { ...prev.tournamentsInfo.ws, key } }
    }))
  }

  async getTournamentsAuthorizationToken() {
    const url = `https://${this._urlParams.api}` + `/game_init?sid=${this._urlParams.sid}&gid=${this._urlParams.gid}`;
    return await ManagerHttp.getRequest(url).then(data => {
      if (!data) return;
      return data.tournaments;
    }).catch((error) => {
      console.error(error);
    });
  }

  //todo: move to separate controller or tournamentWSManager
  _onTournamentWSMessage({ id, type, data }) {
    switch (id) {
      case eTournamentsWS.ETWS_NOTIFICATION: {
        this._handleTournamentNotification(type, data);
        break;
      }
    }
  }

  _handleTournamentNotification(type, data) {
    //todo: add start/end tournament handle (also sidebar init button)
    switch (type) {
      case eNotificationTypes.BONUSES: {
        const { tournamentId, ...info } = data;

        this._wrapperModel.update(prev => ({
          ...prev,
          tournamentsInfo: {
            ...prev.tournamentsInfo,
            data: {
              ...prev.tournamentsInfo.data,
              [tournamentId]: { ...prev.tournamentsInfo.data[tournamentId], bonuses: info.bonuses }
            }
          }
        }));
        break;
      }
      case eNotificationTypes.TOURNAMENT_START: {
        const { tournaments, tournamentId } = data;
        this._wrapperModel.update(prev => ({
          ...prev,
          tournamentsInfo: { ...prev.tournamentsInfo, ...tournaments },
        }));
        window.OPWrapperService.SystemUI.handleTournamentStart(tournamentId);
        break;
      }
      case eNotificationTypes.TOURNAMENT_ANNOUNCEMENT: {
        const { tournaments, tournamentId } = data;
        this._wrapperModel.update(prev => ({
          ...prev,
          tournamentsInfo: { ...prev.tournamentsInfo, ...tournaments },
        }));
        window.OPWrapperService.SystemUI.handleTournamentAnnouncement(tournamentId);
        break;
      }
      case eNotificationTypes.TOURNAMENT_END: {
        const { tournaments, tournamentId } = data;
        this._wrapperModel.update(prev => ({
          ...prev,
          tournamentsInfo: { ...prev.tournamentsInfo, ...tournaments },
        }));

        window.OPWrapperService.SystemUI.handleTournamentEnd(tournamentId);
        break;
      }
      default: {
        window.OPWrapperService.SystemUI.showNotification(type, data);
      }
    }
  }
}
